import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import SearchContext from '~/context/srp/SearchContext';
import useIsFromComposer from '~/hooks/srp/useIsFromComposer';
import useIsFromSearchBar from '~/hooks/srp/useIsFromSearchBar';

export default function useRegenerateSearchSessionId() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { regenerateSearchSessionId } = useContext(SearchContext);
  const isFromComposer = useIsFromComposer();
  const isFromSearchBar = useIsFromSearchBar();

  // If applied filters changed and now none exist, or filters come from composer or search bar, start a new search session
  useSubsequentEffect(() => {
    if (
      Object.keys(appliedFilters).length === 0 ||
      isFromComposer ||
      isFromSearchBar
    ) {
      regenerateSearchSessionId();
    }
  }, [
    appliedFilters,
    isFromComposer,
    isFromSearchBar,
    regenerateSearchSessionId
  ]);
}
